import { loadScript } from '../theme.js';
class CylindoProductViewer extends HTMLElement {
  constructor() {
    super();

    this.cylindoProductViewer = this;

    // Create an empty array to use later
    // this.jsonAlternateImages = [];

    // Get product data from JSON element on product page
    this.productJsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);

    // Get product data from this specific product
    this.productJson = this.productJsonData['product'];

    this.initScript();

  }

  initScript() {
    loadScript('https://viewer.cylindo.com/v4/viewer.min.js')
    .then((data) => {
      console.log('script successfully loaded', data);

      // Initialize Cylindo with metafield data and the current selected variant
      this.initCylindo();

    })
    .catch((error) => {
      console.error(error);
    });
  }

  initCylindo() {

    // Get initial variant
    let initialVariant = this.productJsonData['selected_variant_id'];

    // Get Cylindo data
    let productMetafieldCylindo = this.productJsonData['configuration']['metafields']['cylindo'];

    // Initialize viewerInstance to use later
    let viewerInstance = null;

    // Set the initial values for the first Cylindo product
    this.jsonAlternateImages = [];
    let cylindoContent = productMetafieldCylindo[initialVariant] ? productMetafieldCylindo[initialVariant]['enable_cylindo'] : false;
    let productCode = productMetafieldCylindo[initialVariant] ? productMetafieldCylindo[initialVariant]['cylindo_productcode'] : 'NONE';
    let productFeatures = productMetafieldCylindo[initialVariant] ? productMetafieldCylindo[initialVariant]['cylindo_productfeatures'] : [];
    let thumbsEnabled = true;
    let thumbPageSize = 5;

    this.getCylindoAlternateImages();

    // const mobileView = window.matchMedia('(max-width: 749px)');
    // if (mobileView.matches) {
    //   thumbsEnabled = true;
    //   // Get Shopify product images and add then to the Cylindo thumbnail viewer
    //   this.getCylindoAlternateImages();
      // }


    // Check if the Cylindo JS libary is loaded
    if (typeof cylindo !== 'undefined') {
      cylindo.on(
        'ready',
        function () {
          // Set the initial options for the viewer
          var opts = {
            containerID: '#cylindo-product-viewer',
            accountID: 5084,
            presentation: 'threesixty',
            productCode: productCode,
            features: productFeatures,
            progressBar: true,
            thumbs: thumbsEnabled,
            fullscreen: false,
            environmentZoom: false,
            styleshotsZoom: false,
            alternateContentZoom: false,
            tooltipAltImgText: '',
            tooltipStyleshotText : '',
            tooltipDragText: 'Drag to rotate. Click to zoom.',
            thumbLocation: 'bottom',
            thumbPageSize: thumbPageSize,
            frames: [30],
            alternateContent: this.jsonAlternateImages,
            cylindoContent: cylindoContent,
            debug: false
          };

          // Create the viewerInstance with above options
          viewerInstance = cylindo.viewer.create(opts);

          // If any error, log it
          viewerInstance.on(viewerInstance.events.ERROR, function (msg) {
            window.console && console.log('Cylindo viewer Error: ' + msg);
          });

          // Call the updateCylindoFeatures to listen for variant changes and change product image on the Cylindo 360 viewer accordingly
          this.updateCylindoFeatures(viewerInstance, productCode, productFeatures, productMetafieldCylindo);
        }.bind(this)
      );
    }
  }

  getCylindoAlternateImages() {
    // Find all connected Shopify images
    this.productJson['media'].slice(0, 5).forEach(
      function (media) {
        // Create an object with the first five images
        this.jsonAlternateImages.push({ image: media.src });
      }.bind(this)
    );
  }

  updateCylindoFeatures(viewerInstance, productCode, productFeatures, productMetafieldCylindo) {
    // Listen for the customEvent 'variant:changed' fired whenever we change variant
    document.addEventListener('variant:changed', function (event) {
      // 'event.detail.variant' contains the entire product
      let selected_variant = event.detail.variant;

      // Check if we have a viewerInstance before modifying it
      if (viewerInstance) {

        // Check if we have a valid variant that exists
        if (selected_variant) {
          // Set variable values to the new variants values
          productCode = productMetafieldCylindo[selected_variant.id] ? productMetafieldCylindo[selected_variant.id]['cylindo_productcode'] : 'NONE';
          productFeatures = productMetafieldCylindo[selected_variant.id] ? productMetafieldCylindo[selected_variant.id]['cylindo_productfeatures'] : [];

          // If the new variant has any productFeatures defined, update the viewer
          if (productFeatures != null || productFeatures !== undefined) {
            viewerInstance.setFeatures(productMetafieldCylindo[selected_variant.id]['cylindo_productfeatures']);
          }

          // If the new variant has a productCode defined, update the viewer
          if (productCode != null || productCode !== undefined) {
            viewerInstance.setProduct(productMetafieldCylindo[selected_variant.id]['cylindo_productcode']);
          }

          // Scroll to the Cylindo image wrapper thumbnail wrapper smoothly to the intersecting thumbnail
          window.scrollTo({
            top: document.querySelector('#cylindo-product-viewer').offsetTop,
            behavior: 'smooth'
          });

        }
      }
    });
  }
}

customElements.define('cylindo-product-viewer', CylindoProductViewer);
